import { render, staticRenderFns } from "./PickPicDrawer.vue?vue&type=template&id=8fa36cf2&scoped=true"
import script from "./PickPicDrawer.vue?vue&type=script&lang=js"
export * from "./PickPicDrawer.vue?vue&type=script&lang=js"
import style0 from "./PickPicDrawer.vue?vue&type=style&index=0&id=8fa36cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa36cf2",
  null
  
)

export default component.exports